// SocietyList.js (fixed design)
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "react-perfect-scrollbar/dist/css/styles.css";
import { getSociety } from "./APIs/CreateSocietyApi";
import { CSVLink } from "react-csv";
import axios from "axios";
import { BASE_URL } from "./APIs/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { FiSearch, FiDownload, FiEdit2, FiTrash2, FiX } from "react-icons/fi";


export default function UserQuery() {
    const [requests, setRequests] = useState([]);


  useEffect(() => {
    axios
      .post(`${BASE_URL}/request-call/get-request-call`)
      .then((response) => {
        setRequests(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);
 
  return (
    <div className="flex min-h-screen bg-bg-primary text-text-main font-satoshi transition-colors duration-300">
      <Sidebar />

      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        <Header />

        <div className="flex-1 overflow-y-auto p-6 md:p-8 relative">
          {/* Background Elements */}
          <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden opacity-30">
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-900/10 rounded-full blur-[100px]"></div>
            <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-purple-900/10 rounded-full blur-[100px]"></div>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto space-y-6">
            {/* Actions Toolbar */}
            <div className="flex flex-col md:flex-row justify-between items-end md:items-center gap-4 border-b border-border pb-6">
              <div>
                <h1 className="text-3xl font-clash font-bold text-text-main mb-1">
                 USER QUERY
                </h1>
                <p className="text-text-muted text-sm">
                   Monitor and respond to user questions, feedback, and support requests
                </p>
              </div>

              <div className="flex items-center gap-3">
                {/* <div className="relative group">
                  <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted group-focus-within:text-signal-orange transition-colors" />
                  <input
                    type="text"
                    placeholder="Search societies..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 pr-4 py-2 bg-bg-secondary border border-border rounded focus:border-signal-orange focus:outline-none text-sm w-64 transition-all text-text-main placeholder:text-text-muted"
                  />
                </div> */}
        
              </div>
            </div>
            <div className="bg-bg-secondary rounded border border-border overflow-hidden backdrop-blur-sm">
              <div className="grid grid-cols-12 gap-4 p-4 border-b border-border bg-bg-tertiary/50 text-xs font-bold text-text-muted uppercase tracking-wider">
                <div className="col-span-3">Society Details</div>
                <div className="col-span-3">Location</div>
                <div className="col-span-2">Contact</div>
             
                <div className="col-span-2">Date</div>
                <div className="col-span-2 text-right">Actions</div>
              </div>

              {/* Rows */}
              <div className="divide-y divide-border">
                {requests.length === 0 ? (
  <div className="p-8 text-center text-text-muted">
    No User Queries Found
  </div>
) : (
  requests.map((request) => (
    <div
      key={request.requestCallId}
      className="grid grid-cols-12 gap-4 p-4 items-center hover:bg-bg-tertiary transition-colors"
    >
      {/* Name */}
      <div className="col-span-3">
        <div className="font-medium text-text-main">
          {request.name}
        </div>
        <div className="text-xs text-text-muted">
          {request.email}
        </div>
      </div>

      {/* Message */}
      <div className="col-span-3 text-sm text-text-muted">
        {request.message}
      </div>

      {/* Phone */}
      <div className="col-span-2 text-sm text-text-muted">
        {request.phoneNumber}
      </div>

      {/* Date */}
      <div className="col-span-2 text-sm text-text-muted">
        {request.createdDate}
      </div>

      {/* Actions */}
      <div className="col-span-2 flex justify-end gap-2">
        <button
          className="p-2 hover:bg-bg-tertiary rounded text-blue-400"
          title="View"
        >
          <FiEdit2 />
        </button>

        <button
          className="p-2 hover:bg-bg-tertiary rounded text-red-400"
          title="Delete"
        >
          <FiTrash2 />
        </button>
      </div>
    </div>
  ))
)}
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
}
